import { Controller } from "@hotwired/stimulus"
import Handlebars from "handlebars"
import BaseGrid, { html } from "../utils/base_grid"

// Pre-compile templates
const roleBadgeTemplate = Handlebars.compile(`
  <span class="badge badge-{{badgeClass}}">{{role}}</span>
`)

const actionButtonsTemplate = Handlebars.compile(`
  <div class="btn-group">
    <a href="{{editUrl}}" class="btn btn-sm btn-secondary" data-bs-title="{{editLabel}}" data-bs-toggle="tooltip" data-turbo-frame="_top"><i class="fa-solid fa-pen"></i></a>
    {{#unless isCurrentUser}}
      <a href="{{deleteUrl}}" class="btn btn-sm btn-danger" data-bs-title="{{deleteLabel}}" data-bs-toggle="tooltip" data-turbo-method="delete" data-turbo-confirm="{{confirmDelete}}"><i class="fa-solid fa-trash"></i></a>
    {{/unless}}
  </div>
`)

export default class extends Controller {
  static values = { 
    url: String,
    currentUserId: Number,
    translations: Object
  }
  static targets = ["container", "skeleton"]

  connect() {
    const t = this.translationsValue || {}
    const roles = t.roles || {}

    this.baseGrid = new BaseGrid(this, {
      limit: 25,
      columns: [
        { name: t.email || "Email", id: "email" },
        { 
          name: t.role || "Role", 
          id: "role",
          formatter: (cell, row) => {
            const isAdmin = row.cells[4].data
            const isEditor = row.cells[5].data
            let badgeClass = "secondary"
            let role = cell
            
            if (isAdmin) {
              badgeClass = "danger"
              role = roles.admin || "Admin"
            } else if (isEditor) {
              badgeClass = "warning"
              role = roles.editor || "Editor"
            } else {
              role = roles.viewer || "Viewer"
            }
            
            return html(roleBadgeTemplate({ role, badgeClass }))
          }
        },
        { name: t.created || "Created", id: "created_at" },
        { name: "ID", id: "id", hidden: true },
        { name: "IsAdmin", id: "is_admin", hidden: true },
        { name: "IsEditor", id: "is_editor", hidden: true },
        { name: "EditURL", id: "edit_url", hidden: true },
        { name: "DeleteURL", id: "delete_url", hidden: true },
        { 
          name: t.actions || "Actions",
          sort: false,
          formatter: (cell, row) => {
             const id = row.cells[3].data
             const editUrl = row.cells[6].data
             const deleteUrl = row.cells[7].data
             const isCurrentUser = (id === this.currentUserIdValue)
             
             return html(actionButtonsTemplate({ 
               editUrl, 
               deleteUrl, 
               isCurrentUser,
               editLabel: t.edit || "Edit",
               deleteLabel: t.delete || "Delete",
               confirmDelete: t.confirm_delete || "Are you sure you want to delete this user?"
             })) 
          }
        }
      ],
      mapData: (item) => [
        item.email, 
        item.role, 
        item.created_at,
        item.id,
        item.is_admin,
        item.is_editor,
        item.edit_url,
        item.delete_url
      ]
    })
    
    this.grid = this.baseGrid.create()
  }
  
  disconnect() {
    this.baseGrid.destroy()
  }
}
